import React, { useState, useEffect } from "react";
import { Form, Input, Row, Col, Button, message } from "antd";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { getDatabase, update, ref } from "firebase/database";
import { getStorage } from "firebase/storage";
import Firebase from "../../Firebase/Firebase";
import { useAuth } from "../../AuthContext/AuthContext";

const db = getDatabase(Firebase);
const storage = getStorage(Firebase);

const AddLessonPage = ({ id, snapshot, OpenAddLessonPage }) => {
  const { canAccessModule } = useAuth();
  const canUpdateLesson = canAccessModule("LESSONS", "update");
  const [form] = Form.useForm();
  const [addingPage, setAddingPage] = useState(false);

  const handleFinish = async (values) => {
    if (!canUpdateLesson) {
      message.error("You do not have permission to update lessons.");
      return;
    }

    setAddingPage(true);
    try {
      if (!snapshot || !snapshot.exists()) {
        throw new Error("Lesson not found");
      }

      const lessonData = snapshot.val();
      const currentPages = lessonData.pages || [];

      const nextPageOrder =
        currentPages.length > 0
          ? Math.max(...currentPages.map((p) => Number(p.pageOrder || 0))) + 1
          : 0;

      const targetPage = {
        pageName: values.pageName,
        pageOrder: nextPageOrder,
      };
      currentPages.push(targetPage);
      await update(ref(db, `talmidsdb/lessons/${id}`), { pages: currentPages });
      form.resetFields();
      message.success("Component added successfully");
    } catch (error) {
      console.error("Failed to add lesson component:", error);
      setAddingPage(false);
    } finally {
      OpenAddLessonPage(false);
      setAddingPage(false);
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Row gutter={8} align="bottom">
        <Col span={16}>
          <Form.Item
            label="Page Name"
            name="pageName"
            rules={[{ required: true, message: "Enter page name" }]}
          >
            <Input placeholder="Enter page name" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item style={{ marginBottom: '1.5rem' }}>
            <Button
              type="primary"
              htmlType="button"
              loading={addingPage}
              disabled={!canUpdateLesson}
              onClick={() => form.submit()}
              style={{ width: '100%' }}
            >
              Add Page
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default React.memo(AddLessonPage);
